/* eslint func-call-spacing: 0 */
/* eslint no-unexpected-multiline: 0 */
/* eslint no-undef: 0 */
/* eslint import/no-webpack-loader-syntax: 0 */

ace.define('ace/mode/custom_js_highlight_rules', [], function (require, exports, module) {
  'use strict'
  var oop = require('../lib/oop')
  var HtmlHighlightRules = require('./html_highlight_rules').HtmlHighlightRules
  var JavaScriptHighlightRules = require('./javascript_highlight_rules').JavaScriptHighlightRules

  var CustomJsHighlightRules = function () {
    this.$rules = new JavaScriptHighlightRules().getRules()

    for (var i in this.$rules) {
      this.$rules[i].unshift({
        token: 'keyword',
        regex: 'template: *\\`',
        next: 'html-start'
      })
    }
    this.embedRules(HtmlHighlightRules, 'html-', [
      {
        token: 'keyword',
        regex: '\\%>',
        next: 'start'
      },
      {
        token: 'keyword',
        regex: '`',
        next: 'start'
      }
    ])
  }
  oop.inherits(CustomJsHighlightRules, JavaScriptHighlightRules)
  exports.CustomJsHighlightRules = CustomJsHighlightRules
  console.log(ace.define)
})

console.log(ace.define)

ace.define('ace/mode/custom_js', [], function (require, exports, module) {
  'use strict'
  var oop = require('../lib/oop')
  var TextMode = require('./text').Mode
  var CustomJsHighlightRules = require('./custom_js_highlight_rules').CustomJsHighlightRules

  var Mode = function () {
    this.HighlightRules = CustomJsHighlightRules
  }
  oop.inherits(Mode, TextMode);
  (function () {
    // Extra logic goes here. (see below)
  }).call(Mode.prototype)
  exports.Mode = Mode
});

(function () {
  ace.require(['ace/mode/custom_js'], function (m) {
    if (typeof module === 'object' && typeof exports === 'object' && module) {
      module.exports = m
    }
  })
})()
